import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CopyLink as CopyLinkIcon, Check as CheckIcon } from '@ori-ui/icons';
import { Tooltip } from '@ori-ui/mui';
import { useCallback, useState } from 'react';
import { Root, CopyLinkButton, LinkContent } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CopyLinkInputButton = function CopyLinkInputButton(_ref) {
  var link = _ref.link,
    buttonText = _ref.buttonText,
    copiedText = _ref.copiedText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var handleCopyClick = useCallback(async function () {
    await navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 1500);
  }, [link]);
  return /*#__PURE__*/_jsx(Root, {
    onClick: handleCopyClick,
    children: /*#__PURE__*/_jsx(Tooltip, {
      open: copied,
      title: copiedText,
      children: /*#__PURE__*/_jsx(CopyLinkButton, {
        buttonContent: copied ? /*#__PURE__*/_jsx(CheckIcon, {}) : buttonText,
        children: /*#__PURE__*/_jsxs(LinkContent, {
          href: link,
          target: "_blank",
          children: [/*#__PURE__*/_jsx(CopyLinkIcon, {}), " ", link]
        })
      })
    })
  });
};
//# sourceMappingURL=CopyLinkInputWithButton.js.map